import dJSON from 'dirty-json';
import insertCustomForm from '../../js/plugins/dynamic-form';
import tierPricingFunction from '../../modules/evox/quantitybreaks/module-quantitybreaks';

/**
 * Move logo to image
 */
const moveLogo = () => {
  const mainBrandLogo = document.querySelectorAll('.product-summary .product-brand');
  mainBrandLogo.forEach((item) => {
    item.closest('.catalog-single').querySelector('.main-image').append(item);
  });
};

/**
 * product tools wrap
 */
const wrapTools = () => {
  document.querySelectorAll('.product-shopping-actions-addtoquicklist').forEach((item) => {
    const w1 = item.parentElement;
    const w2 = item.closest('.product-shopping-actions').querySelector('.product-compare-action');
    const prodToolsWrap = document.createElement('div');
    prodToolsWrap.classList.add('prod-tools-wrap');
    w1.parentNode.insertBefore(prodToolsWrap, w1);
    prodToolsWrap.append(w1);
    prodToolsWrap.append(w2);
  });
};

/**
 * Product stock
 */
const stock = () => {
  // product warehouse stock
  const productSummary = document.querySelector('.product-summary');
  if (!productSummary) return;

  // For customisable products
  const leadTime = document.querySelector('.tech-specs .item.attr_item_lead_time .col-sm-8 p');

  if (document.querySelector('.showproductlocations') || (leadTime && parseInt(leadTime.textContent, 10) > 900)) {
    const locations = document.querySelector('.showproductlocations');
    if (locations || (leadTime && parseInt(leadTime.textContent, 10) > 900)) {
      const locationDataRaw = locations?.getAttribute('data-locations');

      const stockWrap = document.createElement('div');
      stockWrap.className = 'product-stock-wrap';

      if ((leadTime && parseInt(leadTime.textContent, 10) > 900)) {
        stockWrap.classList.add('hide');
      }

      const stockWrapWrap = document.createElement('div');
      stockWrapWrap.className = 'col-md-12';

      try {
        const locData = JSON.parse(locationDataRaw);
        locData.forEach((data) => {
          const stockEntry = document.createElement('div');
          stockEntry.className = 'stock-entry';
          stockEntry.innerHTML = /* html */ `
          <span class="stock-warehouse">${data.warehouse}</span>
          <span class="stock-quanitity">${data.quantity}</span>
        `;
          stockWrap.append(stockEntry);
        });
      } catch {
        console.log('invalid');
      }

      stockWrapWrap.append(stockWrap);

      document.querySelectorAll('.product-shopping-actions .product-shopping-actions-addtocart').forEach((item) => {
        item.insertAdjacentElement('beforebegin', stockWrapWrap.cloneNode(true));
      });
    } else {
      console.log('no stock');
    }
  } else {
    document.querySelectorAll('.product-shopping-actions .product-shopping-actions-addtocart').forEach((item) => {
      item.insertAdjacentHTML('beforebegin', /* html */ `
        <div class="col-md-12">
          <div class="product-stock-wrap">
            <div class="stock-entry">
              <span class="stock-warehouse">Next Day Stock</span>
              <span class="stock-quanitity">0</span>
            </div>
            <div class="stock-entry">
              <span class="stock-warehouse">Group Stock</span>
              <span class="stock-quanitity">0</span>
            </div>
          </div>
        </div>
      `);
    });

    document.querySelectorAll('.deliv-text p').forEach((item) => {
      item.setAttribute('data-nostockoverride', 'true');
      item.innerHTML = 'Contact Us for <span class="text-orange">Availability</span>';
    });
  }
};

/**
 * Delivery text
 */
const deliveryText = () => {
  const pdp = document.querySelector('.ex-product');
  if (!pdp) return;

  const addDelivText = (str) => {
    const delivEle = document.createElement('div');
    delivEle.className = 'deliv-text';

    const delivEleWrap = document.createElement('div');
    delivEleWrap.className = 'col-md-12';

    const words = str.split(' ');
    words[words.length - 1] = `<span class="text-orange">${words[words.length - 1]}</span>`;
    const wrappedStr = words.join(' ');

    delivEle.innerHTML = /* html */ `
      <img width="60px" src="https://eu.evocdn.io/dealer/1655/content/media/My_Theme/hg-icon-delivery2.svg" />
      <p>${wrappedStr}</p>`;

    delivEleWrap.append(delivEle);
    document.querySelectorAll('.product-shopping-actions').forEach((item) => {
      item.append(delivEle.cloneNode(true));
    });
  };

  // data cusotmised in theme options - this is a fallback
  const leadTimeDefault = {
    1: 'Next Day Delivery',
    2: '2 Day Delivery',
    5: '3-5 Day Delivery',
    7: '7 Day Delivery',
    10: '10 Day Delivery',
    14: '14 Day Delivery',
    15: '10-15 Day Delivery',
    21: '21 Day Delivery',
    28: '21-28 Day Delivery',
    49: '42-49 Day Delivery',
    63: '63 Day Delivery',
  };

  // eslint-disable-next-line no-undef
  const leadTimeObj = (typeof leadTimeData === 'object') ? leadTimeData : leadTimeDefault;
  const leadTime = document.querySelector('.attr_item_lead_time .col-lg-8 p')?.textContent || 0;
  let delivText = 'Contact Us for Availability';
  let nextDay = false;

  const locations = document.querySelector('.showproductlocations');
  if (locations) {
    const locationDataRaw = locations.getAttribute('data-locations');

    try {
      const locData = JSON.parse(locationDataRaw);
      locData.forEach((data) => {
        if (data.warehouse === 'Next Day Stock' && parseInt(data.quantity, 10) > 0) {
          nextDay = true;
        }
      });
    } catch {
      console.log('invalid');
    }
  }

  if (nextDay) {
    delivText = 'Next Day Delivery';
  } else if (leadTime) {
    Object.keys(leadTimeObj).forEach((key) => {
      if (key === leadTime) {
        delivText = leadTimeObj[key];
      }
    });
  }
  addDelivText(delivText);
};

/**
 * Wrap desc & specs, add read more
 */
const wrapDetails = () => {
  const pdp = document.querySelector('.ex-product');
  if (!pdp) return;

  const detailsWrap = document.createElement('div');
  detailsWrap.className = 'details-wrap';
  detailsWrap.innerHTML = '<div class="row"></div>';
  document.querySelector('.mainproductpagedesktop').append(detailsWrap.cloneNode(true));
  document.querySelector('.mainproductpagemobile').append(detailsWrap.cloneNode(true));

  document.querySelectorAll('.productdescription_container').forEach((description) => {
    description.querySelector('.product-description').insertAdjacentHTML('beforeend', '<div class="see-more"><a href="javascript:;">See</a></div>');
    description.closest('.catalog-single').querySelector('.details-wrap .row').append(description);

    description.querySelector('.see-more a').addEventListener('click', () => {
      description.querySelector('.product-description').classList.toggle('nActive');
    });
    description.querySelector('.see-more a').addEventListener('keyup', (e) => {
      if (!(e.key === 'Enter')) return;
      description.querySelector('.product-description').classList.toggle('nActive');
    });
  });

  document.querySelectorAll('.productspecs_container').forEach((specs) => {
    specs.querySelector('.col-lg-12').insertAdjacentHTML('beforeend', `
    <div class="item see-more">
      <div class="row">
        <div class=" col-lg-4 col-sm-4  col-xs-6 text-right"><span><a href="javascript:;">See</a></span></div>
        <div class=" col-lg-8 col-sm-8  col-xs-6"></div>
      </div>
    </div>`);
    specs.closest('.catalog-single').querySelector('.details-wrap .row').append(specs);

    specs.querySelector('.see-more a').addEventListener('click', () => {
      specs.querySelector('.tech-specs').classList.toggle('nActive');
    });
    specs.querySelector('.see-more a').addEventListener('keyup', (e) => {
      if (!(e.key === 'Enter')) return;
      specs.querySelector('.tech-specs').classList.toggle('nActive');
    });
  });
};

/**
 * Move documents underneath image
 */
const moveDocs = () => {
  const pdp = document.querySelector('.ex-product');
  if (!pdp) return;

  document.querySelectorAll('.icons-block').forEach((item) => {
    item.closest('.catalog-single').querySelector('.productimage_container').append(item);
  });
};

/**
 * Print Products - if form data (list) exists, build contact form on page
 */
const printProductForm = () => {
  const prodDataHTML = document.querySelector('.product-form-data');
  if (!prodDataHTML) return;

  document.body.classList.add('ex-pdp-quoteform');

  /**
   * Move desc & specs
   */
  (() => {
    // deccription
    const description = document.querySelector('.desktop .product-description');
    if (description) {
      const descParent = description.closest('.productdescription_container');

      description.classList.remove('col-sm-12', 'form-group');
      document.querySelector('.desktop .product-summary').append(description);

      descParent.remove();
    }

    // move question c2a to specs
    document.querySelector('.desktop .details-wrap > .row')?.append(document.querySelector('.desktop .questions-c2a'));
    document.querySelector('.desktop .questions-c2a')?.classList.add('col-md-2');
  })();

  /**
   * Build the form
   */
  (() => {
    const sku = document.querySelector('.desktop .product-summary').getAttribute('data-sku');
    // eslint-disable-next-line no-undef
    const toEmail = printFormEmail; // Declared in theme options
    let formHTML = '<div class="form-section-1">';

    formHTML += /* html */ `
    <div class="form-group ">
      <label for="sku">Product Code</label>
      <input name="sku" type="text" class="form-control" id="textField1" value="${sku}" readonly>
    </div>
    `;

    prodDataHTML.querySelectorAll(':scope > li').forEach((item) => {
      const name = item.childNodes[0].nodeValue;
      const nameId = name.replace(/\s+/g, '');

      formHTML += /* html */ `
      <div class="form-group">
        <label for="${nameId}">${name}</label>
      `;

      // if there is a nested list, create a seelect box
      if (item.querySelector('ul')) {
        formHTML += /* html */ `<select name="${name}" id="${nameId}" class="form-control">`;

        item.querySelectorAll('li').forEach((entry) => {
          const option = entry.childNodes[0].nodeValue;

          formHTML += /* html */ ` <option>${option}</option>`;
        });

        formHTML += /* html */ `
        </select>
        `;
      // else create a text input box
      } else {
        const placeholder = item.getAttribute('data-placeholder');

        formHTML += `<input type="text" name="${name}" id="${nameId}" class="form-control"`;

        if (placeholder) {
          formHTML += ` placeholder="${placeholder}" `;
        }

        formHTML += '>';
      }
      // close form group
      formHTML += /* html */ `
      </div>
      `;
    });

    formHTML += /* html */ `
    <div class="form-group">
      <label for="messageBlock1">Additonal Info</label>
      <textarea name="Additional Info" id="messageBlock1" rows="3" class="form-control" required></textarea>
    </div>
    `;

    // close section 1
    formHTML += /* html */ `
    </div>
    `;

    formHTML += /* html */`
    <div class="form-section-2">
      <div class="form-group ">
        <label for="textField1">Full Name</label>
        <input name="full name" required type="text" class="form-control" id="textField1" placeholder="Full Name">
      </div>
      <div class="form-group ">
        <label for="textField2">Company Name</label>
        <input name="company name" required type="text" class="form-control" id="textField2" placeholder="Company Name">
      </div>
      <div class="form-group ">
        <label for="textField3">Telephone</label>
        <input name="Telephone" required type="text" class="form-control" id="textField3" placeholder="Telephone">
      </div>
      <div class="form-group">
        <label for="emailInput">Email</label>
        <input type="email" name="email" id="emailInput" value="" class="form-control" required placeholder="Email">
      </div>
      <div class="form-group form-group-submit">
        <div class='toggle-section'><span class="nButton">Request Quote</span><span>< Back</span></div>
        <button type="submit" class="nButton">Send</button>
      </div>
    </div>
    <div class='toggle-section'><span class="nButton">Request Quote</span></div>
    `;

    insertCustomForm('.desktop .product-shopping-actions', toEmail, formHTML);
    insertCustomForm('.mobile .product-shopping-actions', toEmail, formHTML);

    document.querySelectorAll('.pdp-form .toggle-section').forEach((item) => {
      item.addEventListener('click', () => {
        item.closest('.pdp-form').classList.toggle('part2');
      });
    });
  })();
};

const labelProductForm = () => {
  const isPDP = document.querySelector('.ex-product');
  if (!isPDP) return;

  // find label classes in body
  const bodyClasses = document.body.classList;
  // eslint-disable-next-line no-unused-vars
  const labels = Object.entries(bodyClasses).reduce((acc, [key, value]) => {
    if (typeof value === 'string' && value.includes('ex-l-')) {
      acc.push(value);
    }
    return acc;
  }, []);

  // strip body class to leave only ID
  const labelIDs = labels.map((str) => str.replace('ex-l-', ''));

  let formHTML = '';
  // Find matching custom form, if exists
  labelIDs.forEach((label) => {
    if (document.querySelector(`.custom-label-form[data-label="${label}"]`)) {
      formHTML = document.querySelector(`.custom-label-form[data-label="${label}"]`).closest('.contact-form');
    }
  });

  if (!formHTML) return;

  document.body.classList.add('ex-pdp-labelform');

  const sku = document.querySelector('.desktop .product-summary').getAttribute('data-sku');
  formHTML.querySelector('input[id="form-sku"]').value = sku;

  document.querySelector('.desktop .product-shopping-actions').append(formHTML.cloneNode(true));
  document.querySelector('.mobile .product-shopping-actions').append(formHTML.cloneNode(true));
  document.querySelectorAll('.product-shopping-actions .contact-form').forEach((form) => {
    form.classList.remove('hidden');
  });

  // pdp contact form - file upload
  const initUpload = () => {
    let fileUploadIncrement = 0;
    const fileUpload = (file) => {
      const formData = new FormData();
      formData.append('file', file);

      $.ajax({
        method: 'post',
        url: '/ajax/upload-file',
        data: formData,
        processData: false,
        contentType: false,
      }).then((response) => {
        if (response.status === 'success') {
          const { filepath } = response.data;

          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onloadend = (function () {
            return function () {
              document.querySelectorAll('.custom-label-form .file-list').forEach((filelist) => {
                fileUploadIncrement += 1;
                filelist.insertAdjacentHTML('beforeend', /* html */ `
                  <div class="file-wrap">
                    <label for="auditUpload${fileUploadIncrement}">${file.name}</label>
                    <input class="file-path" name="${file.name}-${fileUploadIncrement}" type="hidden" class="form-control" id="auditUpload${fileUploadIncrement}" value="${filepath}">
                    <i id="fileDelete-${fileUploadIncrement}" class="fa fa-trash" aria-hidden="true"></i>
                  </div>
                `);

                const fileWrap = filelist.querySelector('.file-wrap');
                if (fileWrap) {
                  filelist.querySelector('.files-title.hide')?.classList.remove('hide');
                }
              });
              document.querySelectorAll('.file-drop .nButton + span').forEach((span) => {
                span.innerHTML = file.name;
              });
              document.querySelectorAll('.file-wrap i').forEach((item) => {
                const clonedElement = item.cloneNode(true);
                item.parentNode.replaceChild(clonedElement, item);
              });
              document.querySelectorAll('.file-wrap i').forEach((item) => {
                item.addEventListener('click', (e) => {
                  const fileWrapper = e.target.closest('.file-list');
                  e.target.closest('.file-wrap').remove();

                  if (!fileWrapper.querySelector('.file-wrap')) {
                    fileWrapper.querySelector('.files-title').classList.add('hide');
                  }
                });
              });
            };
          }());
        }
      });
    };

    const clickFileUpload = (e) => {
      const form = e.target.closest('form');
      const query = form.querySelectorAll('.file-upload-button');
      query.forEach((input) => {
        input.click();
      });
    };

    const fileUploadChange = (e) => {
      if (e.target.files) {
        fileUpload(e.target.files[0]);
      }
    };

    const dropHandler = (e) => {
      e.preventDefault();

      if (e.dataTransfer.files) {
        fileUpload(e.dataTransfer.files[0]);
      }
    };

    const dragOverHandler = (e) => {
      e.preventDefault();
    };

    const drop = document.querySelectorAll('.file-drop');

    if (drop) {
      drop.forEach((item) => {
        item.addEventListener('drop', dropHandler.bind(this));
        item.addEventListener('dragover', dragOverHandler.bind(this));
        item.querySelector('.nButton')?.addEventListener('click', clickFileUpload.bind(this));
      });
    }

    if (document.querySelector('.file-upload-button')) {
      document.querySelectorAll('.file-upload-button').forEach((input) => {
        input.addEventListener('change', fileUploadChange.bind(this));
      });
    }
  };

  const drop = formHTML.querySelectorAll('.file-drop');

  if (drop) {
    initUpload();
  }

  document.querySelectorAll('.pdp-form .toggle-section').forEach((item) => {
    item.addEventListener('click', () => {
      item.closest('.pdp-form').classList.toggle('part2');
      document.body.classList.toggle('ex-pdp-quoteform');
      window.dispatchEvent(new Event('resize'));
    });
  });
};

const pdpDynamicC2a = () => {
  if (!document.querySelector('.ex-product')) return;

  // get the class name on product-shopping-actions that starts with category_
  const itemCategory = document.querySelector('.product-shopping-actions').className.match(/category_\S+/g)[0];
  if (!itemCategory) return;

  document.querySelectorAll('.dynamic-c2a').forEach((item) => {
    const c2aData = item.data;
    const data = dJSON.parse(c2aData);

    let match = false;

    Object.keys(data).forEach((key) => {
      if (match) return;

      const entry = data[key];
      const { IDs } = entry;
      const { linkURL } = entry;
      const { title } = entry;
      const { text } = entry;
      const { orangeText } = entry;
      const { img } = entry || 'https://eu.evocdn.io/dealer/1655/content/media/My_Theme/hg-about-bg2.jpg';

      if (!IDs.includes(itemCategory)) return;

      match = true;

      item.setAttribute('data-category', itemCategory);
      item.querySelector('a').style.backgroundImage = `url(${img})`;
      if (linkURL) {
        item.querySelector('a').setAttribute('href', linkURL);
      } else {
        item.querySelector('a').removeAttribute('href').style.pointerEvents = 'none';
      }
      item.querySelector('h3').innerHTML = title;
      item.querySelector('h3 + p').innerHTML = text;
      item.querySelector('.text-orange span').innerHTML = orangeText;

      item.parentElement.classList.remove('hidden');
    });
  });
};

const onContractHideQuantityBreaks = () => {
  const onConract = document.querySelector('.productimage_container .badges-wrapper .on_contract');
  if (!onConract) return;

  document.querySelectorAll('.product-shopping-actions').forEach((item) => {
    item.classList.add('hide-quantity-breaks');
  });
};

const pdpInitFunctions = () => {
  stock();
  moveLogo();
  wrapTools();
  wrapDetails();
  moveDocs();
  printProductForm();
  labelProductForm();
  deliveryText();
  pdpDynamicC2a();
  onContractHideQuantityBreaks();
};

// document.addEventListener('live-inventory-done', function () {
pdpInitFunctions();
// }, false);

window.evoXProductChangeCallback = () => {
  pdpInitFunctions();
  stock();
  tierPricingFunction(true, false);
};
